import React from "react";
import AgentAddContent from "../content/AgentAddContent.js";
import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";
import { useAgents } from "../../utils/agents/index.js";
import Layout from "../layout/Layout";

const AgentAdd = () => {
  const { agentId } = useParams()
  const {  agents } = useAgents();

  return (
    <Layout>
        <AgentAddContent agent={agents} agentId={agentId} />
    </Layout>
  );
};

export default AgentAdd;
